
export const WEBSITE_DOMAIN = 'https://www.hubtype.com';
